var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.98584C4.92486 0.98584 0 5.87101 0 11.8972C0 17.3434 4.02254 21.8574 9.28125 22.676V15.0513H6.48828V11.8972H9.28125V9.49328C9.28125 6.75863 10.9235 5.24809 13.4361 5.24809C14.6396 5.24809 15.8984 5.4612 15.8984 5.4612V8.14641H14.5114C13.1449 8.14641 12.7188 8.9875 12.7188 9.85039V11.8972H15.7695L15.2818 15.0513H12.7188V22.676C17.9775 21.8574 22 17.3434 22 11.8972C22 5.87101 17.0751 0.98584 11 0.98584Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2818 14.9658L15.7695 11.8309H12.7188V9.79652C12.7188 8.93887 13.1449 8.10289 14.5114 8.10289H15.8984V5.43399C15.8984 5.43399 14.6396 5.22217 13.4361 5.22217C10.9235 5.22217 9.28125 6.72353 9.28125 9.44158V11.8309H6.48828V14.9658H9.28125V22.5442C9.84128 22.6308 10.4153 22.676 11 22.676C11.5847 22.676 12.1587 22.6308 12.7188 22.5442V14.9658H15.2818Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8945bf051814eb37b6bf534021384d40.svg";
export { ForwardRef as ReactComponent };